var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPdfArrowCircleRight = function SvgPdfArrowCircleRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6942 28.6061C22.6958 28.6061 28.3717 22.9301 28.3717 15.9285C28.3717 8.92691 22.6958 3.25098 15.6942 3.25098C8.69253 3.25098 3.0166 8.92691 3.0166 15.9285C3.0166 22.9301 8.69253 28.6061 15.6942 28.6061Z",
    fill: "#03C297"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0971 21.3547C13.8562 21.3547 13.6153 21.2659 13.4252 21.0758C13.0575 20.7081 13.0575 20.0996 13.4252 19.7319L17.2284 15.9287L13.4252 12.1254C13.0575 11.7578 13.0575 11.1492 13.4252 10.7816C13.7928 10.4139 14.4013 10.4139 14.769 10.7816L19.2441 15.2568C19.6118 15.6244 19.6118 16.2329 19.2441 16.6006L14.769 21.0758C14.5788 21.2659 14.3379 21.3547 14.0971 21.3547Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfArrowCircleRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf-arrow-circle-right.2dade05a.svg";
export { ForwardRef as ReactComponent };